import React from "react";
import { mapAppointmentDateTimeToShowDates } from "shared/utils/fieldsHelper/showFields";
import { getShowTime } from "shared/utils/showDateTimeDisplay";

interface Props {
  dateTime: server.dto.AppointmentDateTime
}

const ShowTime = (props: Props) => {
  const display = getShowTime(mapAppointmentDateTimeToShowDates(props.dateTime));

  if (display.kind === "none") {
    return null;
  }

  if (display.kind === "fallback") {
    return <span className="s1_blue s1_small">{display.text}</span>;
  }

  if (display.kind === "single") {
    return <span className="s1_small">{display.start}</span>;
  }

  if (display.deEmphasizeEnd) {
    return <span className="s1_small">{display.start}&nbsp;-&nbsp;<span className="s1_gray">{display.end}</span></span>;
  }

  return <span className="s1_small">{display.start}&nbsp;-&nbsp;{display.end}</span>;
};

export default ShowTime;
